import React, { ReactNode } from "react";
import ICModal from "./ICModal";
import ICButton from "./ICButton";
import UseTranslationHook from "../../hooks/UseTranslationHook";

interface ICConfirmationModalProps {
  title: string;
  message: string;
  onClose: (value: boolean) => void;
}

const ICConfirmationModal: React.FC<ICConfirmationModalProps> = ({
  title,
  message,
  onClose,
}) => {
  const { t } = UseTranslationHook();

  const convertStringToJSX = (input: string): JSX.Element => {
    // Create a temporary div element to leverage browser parsing
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = input;

    // Function to recursively convert DOM nodes to JSX
    const convertNodeToJSX = (
      node: ChildNode,
      index: number
    ): ReactNode | null => {
      if (node.nodeType === Node.TEXT_NODE) {
        // If it's a text node, just return the text content
        return node.textContent;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // If it's an element, recursively convert its children
        const element = node as HTMLElement;
        const className = element.getAttribute("className") ?? ""; // Get className if present
        const children = Array.from(element.childNodes).map(
          (child, childIndex) => convertNodeToJSX(child, childIndex)
        );

        // Return a React element corresponding to the HTML element
        return React.createElement(
          element.tagName.toLowerCase(),
          { key: index, className }, // Apply the className here
          children
        );
      }
      return null;
    };

    // Convert all child nodes of the tempDiv
    const jsxElements = Array.from(tempDiv.childNodes).map((node, index) =>
      convertNodeToJSX(node, index)
    );
    return <p>{jsxElements}</p>;
  };

  return (
    <ICModal
      onClose={() => {
        onClose(false);
      }}
      title={title}
    >
      <div className="flex-1 overflow-y-scroll">
        {convertStringToJSX(message)}
        <div className="flex w-full justify-center !py-2  space-x-5">
          <ICButton className="w-20" onClick={() => onClose(true)}>
            {t("yes")}
          </ICButton>
          <ICButton
            className="!bg-danger-muted !text-danger w-20"
            onClick={() => onClose(false)}
          >
            {t("no")}
          </ICButton>
        </div>
      </div>
    </ICModal>
  );
};

export default ICConfirmationModal;
